module.exports = __webpack_public_path__ + "img/icon-we-own-locations.1e99e036.png";